(function($) {
	$(document).ready(function(){
		$(".full-story").slideUp();
	    $(".full-room-link").click(function(){
	      $(this).toggleClass('open');
	      $(this).next(".full-story").slideToggle("slow");
	    });
	});
})(jQuery);
